export const MaintenanceMixin = {
  filters: {
    capitalize(value) {
      if (!value) return "";
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    getIcon(inputIcon: string) {
      const chars = inputIcon.split('');

      for (let i = 0; i < chars.length; i++) {
        if (chars[i] === chars[i].toUpperCase() && chars[i] !== "-") {
          chars[i] = '-' + chars[i].toLowerCase();
        }
      }

      return 'mdi-' + chars.join('');
    }
  }
}